/* Cosana gallery strip (2026-10-08, tasks/pdp-ring-gallery): "swap" and "home" click behaviours for the PDP
   thumbnail strip. Port of the click handler in prototype/ring-gallery.html onto Prestige's own gallery:
   <scroll-carousel> and <product-gallery-navigation> keep doing the selecting and aria-current; this script
   only moves thumbnail buttons in the DOM and hides the one whose media sits in the hero. It never sets the
   "hidden" attribute (Prestige maps the click index over non-hidden buttons, in their original order).
   Desktop only (>= 1000px); below that the server order is restored. The snippet renders the default media's
   tile with "is-in-hero" already, so nothing jumps at first paint. */
(() => {
  const setup = (gallery) => {
    if (gallery.dataset.cosanaReady) return;
    gallery.dataset.cosanaReady = '1';
    const mode = gallery.dataset.cosanaMode;

    const carousel = gallery.querySelector('.product-gallery__carousel');
    const nav = gallery.querySelector('product-gallery-navigation');
    if (!carousel || !nav) return;
    const tiles = () => Array.from(nav.querySelectorAll('.product-gallery__thumbnail'));
    const original = tiles();
    if (mode !== 'swap' && mode !== 'home') {
      original.forEach((t) => t.classList.remove('is-in-hero'));
      return;
    }

    const desktop = window.matchMedia('(min-width: 1000px)');
    const tileFor = (cell) => nav.querySelector(`.product-gallery__thumbnail[data-media-id="${cell.dataset.mediaId}"]`);
    const homeTile = original[0];
    let heroTile = nav.querySelector('.product-gallery__thumbnail.is-in-hero');

    // Prototype: slots[k] = prev (swap); home: when the jar leaves the hero it returns to slot 1 and the
    // tile from slot 1 takes the clicked slot. The clicked tile leaves the strip (it is now the hero).
    const apply = (cell) => {
      if (!cell || !desktop.matches) return;
      const next = tileFor(cell);
      if (!next || next === heroTile) return;
      const prev = heroTile;
      if (prev) {
        prev.classList.remove('is-in-hero');
        const first = tiles().find((t) => t !== prev && !t.classList.contains('is-in-hero'));
        if (mode === 'home' && prev === homeTile && first && first !== next) {
          nav.insertBefore(first, next);
          nav.insertBefore(prev, nav.firstElementChild);
        } else {
          nav.insertBefore(prev, next);
        }
      }
      next.classList.add('is-in-hero');
      heroTile = next;
    };
    const reset = () => {
      original.forEach((t) => { t.classList.remove('is-in-hero'); nav.appendChild(t); });
      heroTile = null;
    };
    const current = () => carousel.selectedCell || gallery.querySelector('.product-gallery__media.is-initial');

    ['carousel:select', 'carousel:change', 'carousel:settle'].forEach((type) => {
      carousel.addEventListener(type, (event) => apply(event.detail.cell));
    });
    desktop.addEventListener('change', (event) => (event.matches ? apply(current()) : reset()));
    if (desktop.matches) apply(current()); else reset();
  };

  const init = (root) => root.querySelectorAll('product-gallery[data-cosana-mode]').forEach(setup);
  customElements.whenDefined('product-gallery').then(() => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
